module.exports = __webpack_public_path__ + "static/media/Logo-p2.18d96076.png";